import { ReactElement } from "react";
import { Article } from "../../DataSource";
import { List, ListItem, chakra } from "@chakra-ui/react";
import { ELLIPSISE } from "../../core/utils";
import { Marker, MarkerProps } from "react-map-gl";
import {
  SELECTED_POINT_COLOUR_DARK,
  SELECTED_POINT_COLOUR_LIGHT,
} from "./constants";

interface MarkerMenuProps extends MarkerProps {
  articles: Array<Article>;
  fallbackShortDescription: string;
  focusedId?: string | null;
  onArticleClick?: (article: Article) => void;
  onArticleHover?: (article: Article | null) => void;
  onClose: () => void;
}

export default function MarkerMenu(props: MarkerMenuProps): ReactElement {
  const {
    articles,
    fallbackShortDescription,
    focusedId,
    onArticleClick,
    onArticleHover,
    onClose,
    ...rest
  } = props;

  return (
    <Marker {...rest}>
      <List
        bg="white"
        display="flex"
        flexDirection="column"
        rounded="lg"
        role="menu"
        borderWidth="2px"
        borderColor="gray.300"
        opacity={0.9}
        onMouseLeave={() => onArticleHover?.(null)}
        data-map-highlight-click-ignore
      >
        {articles.map((article, i) => (
          <ListItem
            key={article.id}
            w="100%"
            h="100%"
            px="4"
            py="2"
            roundedTop={i === 0 ? "lg" : undefined}
            roundedBottom={i === articles.length - 1 ? "lg" : undefined}
            cursor="pointer"
            role="menuitemcheckbox"
            bg={
              focusedId === article.id ? SELECTED_POINT_COLOUR_LIGHT : undefined
            }
            _hover={{
              bg:
                focusedId === article.id
                  ? SELECTED_POINT_COLOUR_DARK
                  : "gray.100",
            }}
            {...ELLIPSISE}
            onMouseMove={(e) => e.stopPropagation()}
            onMouseEnter={() => onArticleHover?.(article)}
            onClick={(evt) => {
              evt.stopPropagation();
              onArticleClick?.(article);
              onClose();
            }}
          >
            {(article.shortDescription?.length ?? 0) > 0 ? (
              article.shortDescription
            ) : (
              <chakra.em>{fallbackShortDescription}</chakra.em>
            )}
          </ListItem>
        ))}
      </List>
    </Marker>
  );
}
